import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps";
import { useTranslation } from "react-i18next";

const CustomerInvoiceDiscountGroupAutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label, disabled = false, load = true, infoText, error, helperText }) => {
    const { t } = useTranslation();
    return (
        <AsyncAutoCompleteContained
            label={label ?? t("common.invoiceDiscountGroup")}
            url="/autocompleteApi/GetCustomerInvoiceDiscountGroup"
            valueId={valueId}
            load={load}
            onChange={onChange}
            infoText={infoText}
            error={error}
            helperText={helperText}
            disabled={ disabled}
        />
    );
};

export default CustomerInvoiceDiscountGroupAutoComplete;
